const URL_BASE = 'http://localhost';

function getFileExtensionFromName(fileName: string): string | null {
  const normalized = fileName.trim();
  const dotIndex = normalized.lastIndexOf('.');
  if (dotIndex <= 0 || dotIndex === normalized.length - 1) {
    return null;
  }
  return normalized.slice(dotIndex + 1);
}

export function getFileExtensionFromUrl(url: string): string | null {
  try {
    const parsed = new URL(url, URL_BASE);
    const fileNameFromPath =
      parsed.pathname.split('/').filter(Boolean).pop() ?? '';
    return getFileExtensionFromName(fileNameFromPath);
  } catch {
    return null;
  }
}

export function buildDownloadFileNameWithSuffix(
  originalFileName: string | null | undefined,
  sourceUrl: string,
  suffix: string,
) {
  const normalizedName = (originalFileName ?? '').trim();
  const extensionFromName = getFileExtensionFromName(normalizedName);
  const extension =
    getFileExtensionFromUrl(sourceUrl) ?? extensionFromName ?? 'xlsx';
  const normalizedSuffix = suffix.trim().replace(/\s+/g, '-');
  const fallbackBaseName = 'import';

  const dotIndex = normalizedName.lastIndexOf('.');
  const baseName =
    normalizedName && dotIndex > 0
      ? normalizedName.slice(0, dotIndex)
      : normalizedName || fallbackBaseName;

  if (!normalizedSuffix) {
    return `${baseName}.${extension}`;
  }

  return `${baseName}-${normalizedSuffix}.${extension}`;
}

export function appendDownloadNameQueryParam(
  url: string,
  downloadName: string,
) {
  try {
    const parsed = new URL(url, URL_BASE);
    parsed.searchParams.set('download_name', downloadName);
    return url.startsWith('http')
      ? parsed.toString()
      : parsed.pathname + parsed.search;
  } catch {
    return url;
  }
}

export function triggerFileDownload(url: string, fileName?: string | null) {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.setAttribute('download', fileName ?? '');
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
